<script setup lang="ts">
const {
	text,
	location = "top",
	size = 16,
	maxWidth = 350,
} = defineProps<{
	text?: string;
	location?: "top" | "bottom" | "start" | "end";
	size?: string | number;
	maxWidth?: string | number;
}>();
</script>

<template>
	<span class="cursor-pointer d-inline-flex align-center" tabindex="0">
		<v-icon :size="size" icon="mdi-help-circle-outline" />
		<v-tooltip
			activator="parent"
			:location="location"
			:max-width="maxWidth"
			content-class="text-small"
			open-on-focus
		>
			<slot>{{ text }}</slot>
		</v-tooltip>
	</span>
</template>
